import './Footer.scss';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Logo from '../../assets/Logo.png';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className='footer'>
      <div className='content'>
        <div className='footerLogo' onClick={() => navigate('/')}>
          <img src={Logo} alt='Logo' />
        </div>

        <span className='footerText'>© NextDeavor {format(new Date(), 'yyyy')}</span>
        <a href='#' class='termly-display-preferences footerTerms' id='open-consent'>
          Consent Preferences
        </a>
        <span
          className='footerTerms'
          onClick={() =>
            window.open(
              'https://app.termly.io/policy-viewer/policy.html?policyUUID=77bc3729-f839-44fd-a7b3-4322a6ecc347',
              '_blank',
            )
          }
        >
          Terms and conditions
        </span>
        <span
          className='footerTerms'
          onClick={() =>
            window.open(
              'https://app.termly.io/policy-viewer/policy.html?policyUUID=d99a532f-b139-4ac8-a90a-a5874443d27e',
              '_blank',
            )
          }
        >
          Privacy policy
        </span>
      </div>
    </div>
  );
};

export default Footer;
